
export default (width = 24, height = 24, color = '#309A02') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
        <rect width="15.5" height="15.5" x="1.75" y="1.75" stroke="${color}" stroke-width="1.5" rx="2"/>
        <rect width="16" height="16" x="7" y="7" fill="${color}" rx="2"/>
        <path stroke="#FFF" stroke-width="2" d="M11 15.15L13.905 18 19 13"/>
    </g>
</svg>
`